import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import peopleImg from './people.jpg';
import czImg from './cz.png';
import skImg from './sk.png';
import huImg from './hu.jpg';

import css from './SectionThreeSteps.css';

const COUNTRY_IMAGES = {
  cz: czImg,
  sk: skImg,
  hu: huImg,
};

const SectionThreeSteps = ({ intl }) => {
  const countryId = process.env.REACT_APP_COUNTRY_ID;
  const selectedImage = COUNTRY_IMAGES[countryId] || peopleImg;

  return (
    <div className={css.container}>
      <div className={css.stepsContainer}>
        <h2 className={css.title}>
          <FormattedMessage id="SectionHowItWorks.titleLineOne" />
        </h2>
        <div className={css.steps}>
          <div className={css.step}>
            <h3 className={css.stepTitle}>
              1. <FormattedMessage id="SectionHowItWorks.part1Title" />
            </h3>
            <p className={css.stepText}>
              <FormattedMessage id="SectionHowItWorks.part1Text" />
            </p>
          </div>
          <div className={css.step}>
            <h3 className={css.stepTitle}>
              2. <FormattedMessage id="SectionHowItWorks.part2Title" />
            </h3>
            <p className={css.stepText}>
              <FormattedMessage id="SectionHowItWorks.part2Text" />
            </p>
          </div>
          <div className={css.step}>
            <h3 className={css.stepTitle}>
              3. <FormattedMessage id="SectionHowItWorks.part3Title" />
            </h3>
            <p className={css.stepText}>
              <FormattedMessage id="SectionHowItWorks.part3Text" />
            </p>
          </div>
        </div>
      </div>
      <div className={css.imgContainer}>
        <img
          src={selectedImage}
          className={css.image}
          alt={intl.formatMessage({ id: 'SectionHowItWorks.titleLineOne'})}
        />
      </div>
    </div>
  )
}

export default SectionThreeSteps;